import { useIngredient, useUpdateIngredient } from '../../hooks/useIngredients';

import { IngredientForm } from './IngredientForm';

import { PageHeader } from '@/components/common/PageHeader';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { useNavigate, useParams } from '@/lib/router';
import { logger } from '@/lib/sentry';

export function EditIngredientPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const navigate = useNavigate();
  const { data: ingredient, isLoading } = useIngredient(id);
  const updateIngredient = useUpdateIngredient();

  if (isLoading) {
    return (
      <AppShell>
        <TopBar title="Chargement..." />
        <div className="flex h-64 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-green-600 border-t-transparent" />
        </div>
      </AppShell>
    );
  }

  if (!ingredient) {
    return (
      <AppShell>
        <TopBar title="Ingrédient introuvable" />
        <div className="p-6 text-slate-500">Cet ingrédient n&apos;existe pas.</div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <TopBar title={`Modifier : ${ingredient.name}`} />
      <div className="mx-auto max-w-4xl p-4 md:p-6">
        <PageHeader
          title={`Modifier "${ingredient.name}"`}
          subtitle="Mettre à jour les informations de cet ingrédient"
          actions={
            <button
              type="submit"
              form="ingredient-form"
              disabled={updateIngredient.isPending}
              className="rounded-lg bg-green-600 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 disabled:opacity-60"
            >
              {updateIngredient.isPending ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          }
        />
        <IngredientForm
          mode="edit"
          defaultValues={ingredient}
          isLoading={updateIngredient.isPending}
          onCancel={() => void navigate({ to: '/ingredients' })}
          onSubmit={async (data) => {
            try {
              console.log('SUBMITTING INGREDIENT DATA:', data);
              await updateIngredient.mutateAsync({
                id,
                data: data as Parameters<typeof updateIngredient.mutateAsync>[0]['data'],
              });
              await navigate({ to: '/ingredients' });
            } catch (error) {
              logger.error(error, { context: 'updateIngredient' });
              alert(
                `Erreur lors de la sauvegarde : ${(error as Error).message || 'Vérifiez la console'}`,
              );
            }
          }}
        />
      </div>
    </AppShell>
  );
}
